import { tns } from 'tiny-slider/src/tiny-slider';

class ImageGallerySlider {
	constructor(el, prevButton, nextButton, nav) {
		console.log(this.nav);
		this.el = el;
		this.prevButton = prevButton;
		this.nextButton = nextButton;
		this.nav = nav;
		const numSlides = parseInt(this.el.getAttribute('data-value')) || 1;
		console.log(numSlides);

		const imageGallerySlider = tns({
			container: this.el,
			responsive: {
				350: {
					items: 1
				},
				1025: {
					items: numSlides
				},
			},
			items: numSlides,
			slideBy: numSlides,
			autoplay: true,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			controls: true,
			prevButton: this.prevButton,
			nextButton: this.nextButton,
			nav: true,
			navPosition: "bottom",
			navContainer: this.nav,
			autoHeight: true
		});

		return imageGallerySlider;

	}
}

export default ImageGallerySlider;